<template>
    <span :class="formatClass" :style="{'font-size': size}">

        <template v-if="sign">{{rateSign}}</template>{{formatNum}}<template v-if="mark">%</template>        
    </span>
</template>
<script>
    import {isString, isNumeric} from '../../utils/base'
    export default {
        name : 'k-updown',
        props : {
            value : {
                type: Number,
                default : 0
            },
            mark : {
                type : Boolean,
                default : false
            },
            size : {
                type : String,
                default : ''
            },
            fixed : {
                type : Number,
                default : 2
            },
            sign : {
                type : Boolean,
                default : false
            },
            skin : {
                type : [Number, Boolean],
                default : null
            }
        },
        computed: {
            formatNum(){
                let {fixed, value} = this
                if(fixed > 0){
                    value = +value.toFixed(fixed)
                }
                return value
            },
            rateSign() {
                return this.sign === true ? this.value < 0 ? '-' : '+' : ''
            },
            formatClass(){
                const {skin, value} = this
                if(isNumeric(skin)){
                    return skin < 0 ? 'down' : skin > 0 ? 'up' : 'flat'                    
                } else if(isString(skin) && skin) {
                    return skin
                } else if (skin === false) {
                    return ''
                }                    
                return value < 0 ? 'down' : skin > 0 ? 'up' : 'flat'
            }
        },
        methods: {
            
        },
    }
</script>
<style lang="less">
    .up {
        color : #DB3439;
    }
    .down {
        color : #93C958;
    }
</style>